import { PlatformType } from '@/react/portainer/environments/types';
import { getPlatformType } from '@/react/portainer/environments/utils';

const EDGE_ADMIN_ID = 0;
const NAMESPACE_OPERATOR_ID = 6;

const edgeAdminRole = {
  Id: EDGE_ADMIN_ID,
  Name: 'Edge administrator',
  Description: 'Full control of all resources in all edge environments and access to the Edge Compute features',
  Priority: 1,
  Scope: {
    kubernetes: ['*'],
    podman: ['*'],
    docker: ['*'],
    swarm: ['*'],
  },
};

/* @ngInject */
export function RoleService(Roles) {
  return {
    roles,
    rolesWithEdgeAdmin,
  };

  async function roles(entityType = null, entity = null) {
    const roles = await Roles.query({}).$promise;

    // If these are the role options for a non-Kubernetes environment, remove the Namespace Operator role
    if (entityType === 'endpoint' && entity && getPlatformType(entity.Type) !== PlatformType.Kubernetes) {
      return roles.filter((role) => role.Id !== NAMESPACE_OPERATOR_ID);
    }

    // If these are the role options for a group then append (Kubernetes only) to the Namespace Operator role label
    if (entityType === 'group') {
      return roles.map((role) => {
        if (role.Id === NAMESPACE_OPERATOR_ID) {
          return { ...role, Name: `${role.Name} (Kubernetes only)` };
        }
        return role;
      });
    }

    return roles;
  }

  async function rolesWithEdgeAdmin() {
    const data = await roles();
    // manually put the edge admin role as it is not an RBAC role in the backend
    // but is defined by user.Role = Role.EdgeAdministrator (3)
    data.push(edgeAdminRole);
    return data;
  }
}
